'use strict';
var $ = require('jquery'),
  Backbone = require('backbone'),
  AccelerateGrowth = Backbone.View.extend({
    initialize: function() {
      this.countNumber()
      $(window).on('scroll', () => {
        this.countNumber()
      })
    },
    countNumber() {
      const scrHeight =  window.innerHeight
      const scrollDown = $(window).scrollTop()
      const positEle = this.$el.offset().top
      if (scrollDown > positEle - scrHeight) {
        if ($(window).width() >= 1024 && !this.$el.hasClass('is-editor-mode') && !this.$el.hasClass('has-counted')) {
          const $numberCount = this.$el.find('.AccelerateGrowth-content--numberCount')
          $numberCount.css('opacity', 1).each((ind, e) => {
            const number = $(e).text().match(/\d+/)
            const textAfter = $(e).text().replace(number, '').trim()
            $(e).countTo({
              from: 0,
              to: number,
              speed: 2000,
              formatter: (value, options) => {
                return value.toFixed(options.decimals) + textAfter
              }
            })
          });
          this.$el.addClass('has-counted')
        }
      }
    }
  }, {
    create: function create($parent) {
      $parent.find('.AccelerateGrowth').each((n, el) => {
        new AccelerateGrowth({
          el: el
        });
      });
    }
  });

module.exports = AccelerateGrowth;


// WEBPACK FOOTER //
// ./assets/components/AccelerateGrowth/AccelerateGrowth.js